import ReviewStars from 'storeDesignBuilder/components/editor/form/components/layout/Sections/components/CustomerReviewsSection/components/ReviewItem/ReviewStars/ReviewStars';
import { customizedFmt, fmt, intl } from 'components/IntlWrapper/IntlWrapper';

import BannerLayout1 from 'assets/icons/store-editor/banner-layout-1.png';
import BannerLayout2 from 'assets/icons/store-editor/banner-layout-2.png';
import BannerLayout3 from 'assets/icons/store-editor/banner-layout-3.png';

import VideoDefaultLayout from 'assets/icons/store-editor/video-layout.png';
import VideoSplitLayout from 'assets/icons/store-editor/video-layout-split.png';
import VideoSplitLayoutAr from 'assets/icons/store-editor/video-layout-split-ar.png';

import HeaderLayout1 from 'assets/icons/store-editor/header-layout-1.png';
import HeaderLayout2 from 'assets/icons/store-editor/header-layout-2.png';
import HeaderLayout3 from 'assets/icons/store-editor/header-layout-3.png';
import HeaderLayout4 from 'assets/icons/store-editor/header-layout-4.png';
import FooterLayout1 from 'assets/icons/store-editor/footer-layout-1.png';
import FooterLayout2 from 'assets/icons/store-editor/footer-layout-2.png';
import FooterLayout3 from 'assets/icons/store-editor/footer-layout-3.png';
import FooterLayout4 from 'assets/icons/store-editor/footer-layout-4.png';
import ReviewRowLayout from 'assets/images/review-row.png';
import ReviewColumnLayout from 'assets/images/review-column.png';
import ReviewCenterLayout from 'assets/images/review-center.png';
import { ReactComponent as LeftAlign } from 'assets/icons/left-align.svg';
import { ReactComponent as RightAlign } from 'assets/icons/right-align.svg';
import { ReactComponent as CenterAlign } from 'assets/icons/center-align.svg';
import { ReactComponent as Fit } from 'assets/icons/fit.svg';
import { ReactComponent as Fill } from 'assets/icons/fill.svg';

import CategoryTwoGridLayout from 'assets/icons/store-editor/category-two-grid.png';
import CategoryFourGridLayout from 'assets/icons/store-editor/category-four-grid.png';

import { ReactComponent as ProductsLogo } from 'assets/bosta-icons/Product.svg';
import { ReactComponent as BannerLogo } from 'assets/icons/banner.svg';
import { ReactComponent as CategoryLogo } from 'assets/icons/categories.svg';
import { ReactComponent as CategoriesLogo } from 'assets/icons/categories.svg';
import { ReactComponent as CustomerReviewsLogo } from 'assets/icons/message-heart-square.svg';
import { ReactComponent as PlayIcon } from 'assets/icons/play-circle.svg';
import { ReactComponent as LogoListIcon } from 'assets/icons/logo-list.svg';
import { ReactComponent as MailIcon } from 'assets/icons/mail.svg';
import { ReactComponent as MarkerIcon } from 'assets/icons/marker-pin.svg';
import logoList from 'assets/images/logo-list.png';
import BannerPreview from 'assets/bosta-images/banner-preview.png';
import ProductsPreview from 'assets/bosta-images/products-preview.png';
import BannerPreviewAr from 'assets/bosta-images/banner-preview-ar.png';
import ProductsPreviewAr from 'assets/bosta-images/products-preview-ar.png';
import CategoriesPreview from 'assets/bosta-images/categories-Preview.png';
import CategoriesPreviewAr from 'assets/bosta-images/categories-Preview-ar.png';
import CustomerReviewsPreview from 'assets/bosta-images/customer-reviews-preview.png';
import CustomerReviewsPreviewAr from 'assets/bosta-images/customer-reviews-preview-ar.png';
import VideosPreview from 'assets/bosta-images/VideosPreview.png';
import Benefits from 'assets/images/benefits.png';
import { LOCALE } from './intl-wrapper';

const BANNER_IMAGE_PLACEHOLDER =
  'https://storage.googleapis.com/bosta-fe/Business-Dashboard/BannerPlaceholder.png';

export const COMMON_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  AUTO: 'auto'
};

export const COMMON_ALIGNMENT = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};

const COMMON_SIZE_VALUES = [
  {
    label: COMMON_SIZES.SMALL,
    content: fmt({ id: 'store_design.store_editor.small_logo' })
  },
  {
    label: COMMON_SIZES.MEDIUM,
    content: fmt({ id: 'store_design.store_editor.medium_logo' })
  },
  {
    label: COMMON_SIZES.LARGE,
    content: fmt({ id: 'store_design.store_editor.large_logo' })
  }
];

export const CUSTOMER_REVIEWS_MAX_STARS_RATE = 5;

export const CUSTOMER_REVIEWS_INITIAL_VALUES = {
  type: 'customerReviews',
  name: 'customerReviews',
  title: fmt({
    id: 'store_design.reviews_section.title_for_store'
  }),
  titleAr: customizedFmt(LOCALE.AR)({
    id: 'store_design.reviews_section.title_for_store'
  }),
  customerReviews: [
    {
      image:
        'https://storage.googleapis.com/bosta-files/sllr_store_images/review-customer-placeholder.png',
      auther: fmt({
        id: 'store_design.reviews_section.initial_reviews.review_1.auther'
      }),
      autherAr: customizedFmt(LOCALE.AR)({
        id: 'store_design.reviews_section.initial_reviews.review_1.auther'
      }),
      description: fmt({
        id: 'store_design.reviews_section.initial_reviews.review_1.description'
      }),
      descriptionAr: customizedFmt(LOCALE.AR)({
        id: 'store_design.reviews_section.initial_reviews.review_1.description'
      }),
      rating: CUSTOMER_REVIEWS_MAX_STARS_RATE
    },
    {
      image:
        'https://storage.googleapis.com/bosta-files/sllr_store_images/review-customer-placeholder.png',
      auther: fmt({
        id: 'store_design.reviews_section.initial_reviews.review_2.auther'
      }),
      autherAr: customizedFmt(LOCALE.AR)({
        id: 'store_design.reviews_section.initial_reviews.review_2.auther'
      }),
      description: fmt({
        id: 'store_design.reviews_section.initial_reviews.review_2.description'
      }),
      descriptionAr: customizedFmt(LOCALE.AR)({
        id: 'store_design.reviews_section.initial_reviews.review_2.description'
      }),
      rating: CUSTOMER_REVIEWS_MAX_STARS_RATE
    },
    {
      image:
        'https://storage.googleapis.com/bosta-files/sllr_store_images/review-customer-placeholder.png',
      auther: fmt({
        id: 'store_design.reviews_section.initial_reviews.review_3.auther'
      }),
      autherAr: customizedFmt(LOCALE.AR)({
        id: 'store_design.reviews_section.initial_reviews.review_3.auther'
      }),
      description: fmt({
        id: 'store_design.reviews_section.initial_reviews.review_3.description'
      }),
      descriptionAr: customizedFmt(LOCALE.AR)({
        id: 'store_design.reviews_section.initial_reviews.review_3.description'
      }),
      rating: CUSTOMER_REVIEWS_MAX_STARS_RATE
    }
  ]
};

export const LOGO_SIZE = COMMON_SIZE_VALUES;

export const BANNER_SIZE = [
  ...COMMON_SIZE_VALUES,
  {
    label: COMMON_SIZES.AUTO,
    content: fmt({ id: 'store_design.store_editor.auto_logo' })
  }
];

export const BANNER_ALIGNMENT = [
  { label: COMMON_ALIGNMENT.LEFT, icon: <LeftAlign /> },
  { label: COMMON_ALIGNMENT.CENTER, icon: <CenterAlign /> },
  { label: COMMON_ALIGNMENT.RIGHT, icon: <RightAlign /> }
];

export const LOGO_SIZE_KEY = 'logoSize';
export const BANNER_HEIGHT_KEY = 'bannerHeight';
export const BANNER_SIZE_KEY = 'buttonSize';
export const BANNER_ALIGNMENT_KEY = 'bannerAlignment';

export const BANNER_SIZE_OPTIONS = [
  {
    title: fmt({ id: `store_design.banner.banner_height` }),
    value: BANNER_HEIGHT_KEY,
    options: BANNER_SIZE,
    defaultValue: COMMON_SIZES.LARGE
  },
  {
    title: fmt({ id: `store_design.banner.button_size` }),
    value: BANNER_SIZE_KEY,
    options: LOGO_SIZE,
    defaultValue: COMMON_SIZES.MEDIUM
  },
  {
    title: fmt({ id: `store_design.banner.banner_alignment` }),
    value: BANNER_ALIGNMENT_KEY,
    options: BANNER_ALIGNMENT,
    defaultValue: COMMON_ALIGNMENT.CENTER
  }
];

export const RECOMMENDED_COLORS = [
  '#0E9888',
  '#11181C',
  '#ED5F00',
  '#5D770D',
  '#CD2B31',
  '#006ADC',
  '#793AAF',
  '#297C3B',
  '#E03177',
  '#886349'
];

export const BORDER_SHAPES = [
  {
    name: 'sharp',
    value: '0px',
    label: fmt({
      id: `store_design.store_editor.sharp`
    })
  },
  {
    name: 'semi',
    value: '8px',
    label: fmt({
      id: `store_design.store_editor.semi-round`
    })
  },
  {
    name: 'rounded',
    value: '20px',
    label: fmt({
      id: `store_design.store_editor.rounded`
    })
  }
];

export const DEFAULT_COLOR_SCHEMES = ['light', 'dark', 'shaded'];

export const BANNER_LAYOUT_TYPES = {
  DEFAULT: 'default-banner-layout',
  IMAGE_SPLIT: 'image-split-default-banner-layout',
  IMAGE_HEADER: 'image-header-default-banner-layout'
};

export const VIDEO_LAYOUT_TYPES = {
  DEFAULT: 'default-video-layout',
  VIDEO_SPLIT: 'video-split-layout'
};

export const VIDEO_LAYOUTS = [
  {
    value: VIDEO_LAYOUT_TYPES.DEFAULT,
    image: VideoDefaultLayout
  },
  {
    value: VIDEO_LAYOUT_TYPES.VIDEO_SPLIT,
    image: intl.locale === 'en' ? VideoSplitLayout : VideoSplitLayoutAr
  }
];

export const BANNER_LAYOUTS = [
  {
    value: BANNER_LAYOUT_TYPES.DEFAULT,
    image: BannerLayout1
  },
  {
    value: BANNER_LAYOUT_TYPES.IMAGE_SPLIT,
    image: BannerLayout2
  },
  {
    value: BANNER_LAYOUT_TYPES.IMAGE_HEADER,
    image: BannerLayout3
  }
];

export const STORE_EDITOR_MODES = {
  HEADER: 'header',
  FOOTER: 'footer',
  MAIN: 'main',
  BANNER: 'banner',
  PRODUCTS: 'products',
  CATEGORIES: 'categories',
  CUSTOMER_REVIEWS: 'customerReviews'
};

export const PANEL_KEYS = {
  DESIGN: 'design-style',
  HOMEPAGE: 'home-page'
};

export const STORE_EDITOR_PANELS = {
  basic: PANEL_KEYS.DESIGN,
  proTheme1: PANEL_KEYS.HOMEPAGE
};

export const HEADER_LAYOUT_TYPES = {
  MENU_AND_CENTERED_LOGO: 'MENU_AND_CENTERED_LOGO',
  MENU_AND_SIDE_LOGO: 'MENU_AND_SIDE_LOGO',
  CENTERED_LINKS_AND_CENTERED_LOGO: 'CENTERED_LINKS_AND_CENTERED_LOGO',
  SIDE_LINKS_AND_SIDE_LOGO: 'SIDE_LINKS_AND_SIDE_LOGO'
};

export const REVIEW_LAYOUT_TYPES = {
  ROW: 'ROW',
  CENTERED: 'CENTERED',
  COLUMN: 'COLUMN'
};

export const HEADER_LAYOUTS = [
  {
    value: HEADER_LAYOUT_TYPES.MENU_AND_CENTERED_LOGO,
    image: HeaderLayout1
  },
  {
    value: HEADER_LAYOUT_TYPES.MENU_AND_SIDE_LOGO,
    image: HeaderLayout2
  },
  {
    value: HEADER_LAYOUT_TYPES.CENTERED_LINKS_AND_CENTERED_LOGO,
    image: HeaderLayout3
  },
  {
    value: HEADER_LAYOUT_TYPES.SIDE_LINKS_AND_SIDE_LOGO,
    image: HeaderLayout4
  }
];

export const FOOTER_LAYOUT_TYPES = {
  PLAIN: 'PLAIN',
  STORE_NAME: 'STORE_NAME',
  STORE_NAME_DESCRIPTION: 'STORE_NAME_DESCRIPTION',
  STORE_NAME_DESCRIPTION_LINKS: 'STORE_NAME_DESCRIPTION_LINKS'
};

export const FOOTER_LAYOUTS = [
  {
    value: FOOTER_LAYOUT_TYPES.PLAIN,
    image: FooterLayout1
  },
  {
    value: FOOTER_LAYOUT_TYPES.STORE_NAME,
    image: FooterLayout2
  },
  {
    value: FOOTER_LAYOUT_TYPES.STORE_NAME_DESCRIPTION,
    image: FooterLayout3
  },
  {
    value: FOOTER_LAYOUT_TYPES.STORE_NAME_DESCRIPTION_LINKS,
    image: FooterLayout4
  }
];

export const RECOMMENDED_WIDTH = {
  web: {
    'image-split-default-banner-layout': '720',
    'default-banner-layout': '1440',
    'image-header-default-banner-layout': '1440'
  },
  mobile: {
    'image-split-default-banner-layout': '400',
    'default-banner-layout': '400',
    'image-header-default-banner-layout': '400'
  }
};

export const RECOMMENDED_HEIGHT = {
  web: {
    large: '600',
    medium: '475',
    small: '350',
    auto: '600'
  },
  mobile: {
    large: '450',
    medium: '400',
    small: '320',
    auto: '560'
  }
};

export const BANNER_OVERLAY = 20;

export const LOCALIZE_TITLE = {
  EN: 'title',
  AR: 'titleAr'
};

export const LOCALIZE_DESCRIPTION = {
  EN: 'description',
  AR: 'descriptionAr'
};

export const REVIEWS_LAYOUTS = [
  {
    value: REVIEW_LAYOUT_TYPES.ROW,
    image: ReviewRowLayout
  },
  {
    value: REVIEW_LAYOUT_TYPES.COLUMN,
    image: ReviewColumnLayout
  },
  {
    value: REVIEW_LAYOUT_TYPES.CENTERED,
    image: ReviewCenterLayout
  }
];

const BENEFITS_INTIAL_VALUES = {
  type: 'benefits',
  title: 'Our Benefits',
  titleAr: 'فوائدنا',
  name: 'benefits',
  description: 'Your benefits description goes here.',
  descriptionAr: 'وصف فوائدك يذهب هنا.',
  colorScheme: 'LIGHT',
  benefits: [
    {
      title: 'Fast Delivery',
      titleAr: 'توصيل سريع',
      description:
        'We deliver your purchase within two business days after receiving your order.',
      descriptionAr: 'نقوم بتوصيل مشترياتك خلال يومي عمل بعد استلام طلبك.',
      icon: 'Truck'
    },
    {
      title: 'High Quality',
      titleAr: 'جودة عالية',
      description: 'Our products have the top quality in the market.',
      descriptionAr: 'منتجاتنا تتمتع بأعلى جودة في السوق.',
      icon: 'Shield'
    },
    {
      title: 'Inspect & Return',
      titleAr: 'التفتيش والإرجاع',
      description: 'You can inspect the product upon delivery and return it.',
      descriptionAr: 'يمكنك معاينة المنتج عند التسليم وإعادته',
      icon: 'Undo2'
    }
  ]
};

export const FONTS_OPTIONS = [
  { label: 'default', value: 'default' },
  {
    label: 'classic',
    value: 'ElMessiri',
    fontClassname: 'font-family__ElMessiri'
  },
  {
    label: 'comfortable',
    value: 'Roboto',
    fontClassname: 'font-family__Roboto'
  }
];

export const PRODUCT_IMAGE_LAYOUT_OPTIONS = [
  {
    label: fmt({ id: 'store_design.store_editor.portrait' }),
    value: 'portrait',
    icon: null
  },
  {
    label: fmt({ id: 'store_design.store_editor.square' }),

    value: 'square',
    icon: null
  }
];

export const PRODUCT_IMAGE_FIT_OPTIONS = [
  {
    label: fmt({ id: 'store_design.store_editor.fill' }),

    value: 'fill',
    icon: <Fill className="ant-icon-md" />
  },
  {
    label: fmt({ id: 'store_design.store_editor.fit' }),
    value: 'fit',
    icon: <Fit className="ant-icon-md" />
  }
];

export const CATEGORIES_LAYOUTS_OPTIONS = {
  FOUR_GRID: 'four-grid',
  TWO_GRID: 'two-grid'
};

export const CATEGORIES_LAYOUTS = [
  {
    value: CATEGORIES_LAYOUTS_OPTIONS.FOUR_GRID,
    image: CategoryFourGridLayout
  },
  {
    value: CATEGORIES_LAYOUTS_OPTIONS.TWO_GRID,
    image: CategoryTwoGridLayout
  }
];

export const HOME_SECTIONS_BUTTONS = [
  {
    label: fmt({
      id: `store_design.sections_modal.banner`
    }),
    icon: BannerLogo,
    name: 'banner',
    comingSoon: false
  },
  {
    label: fmt({ id: 'nav_bar.products' }),
    icon: ProductsLogo,
    name: 'products',
    comingSoon: false
  },
  {
    label: fmt({
      id: `store_design.sections_modal.categories`
    }),
    icon: CategoriesLogo,
    name: 'categories',
    comingSoon: false
  },
  {
    label: fmt({
      id: `store_design.sections_modal.testimonials`
    }),
    icon: CustomerReviewsLogo,
    name: 'testimonials',
    comingSoon: false
  },
  {
    label: fmt({
      id: `store_design.sections_modal.benefits`
    }),
    icon: LogoListIcon,
    name: 'benefits',
    comingSoon: false
  },
  {
    label: fmt({
      id: `store_design.sections_modal.video`
    }),
    icon: PlayIcon,
    name: 'video',
    comingSoon: false
  },
  {
    label: fmt({
      id: `store_design.sections_modal.logo_list`
    }),
    icon: LogoListIcon,
    name: 'logos',
    comingSoon: false
  },

  {
    label: fmt({
      id: `store_design.sections_modal.news`
    }),
    icon: MailIcon,
    name: 'news',
    comingSoon: true
  },
  {
    label: fmt({
      id: `store_design.sections_modal.map`
    }),
    icon: MarkerIcon,
    name: 'map',
    comingSoon: true
  }
];

export const HOME_SECTIONS = [
  {
    label: fmt({
      id: `store_design.sections_modal.banner`
    }),
    image: intl.locale === 'en' ? BannerPreview : BannerPreviewAr,
    sectionDefaultData: {
      type: 'banner',
      title: 'Banner',
      titleAr: 'صور رئيسية',
      name: 'banner',
      isNewAdded: true,
      layout: BANNER_LAYOUT_TYPES.DEFAULT,
      banners: [
        {
          title: 'Your Title Here!',
          titleAr: 'عنوانك هنا!',
          description: 'Your description goes here.',
          descriptionAr: 'الوصف الخاص بك يذهب هنا.',
          image: BANNER_IMAGE_PLACEHOLDER
        }
      ]
    },
    icon: BannerLogo,
    comingSoon: false
  },
  {
    label: fmt({ id: 'nav_bar.products' }),
    image: intl.locale === 'en' ? ProductsPreview : ProductsPreviewAr,
    sectionDefaultData: {
      type: 'products',
      isNewAdded: true,
      title: 'Featured Products',
      titleAr: 'منتجات مميزه',
      name: 'trendingProducts'
    },
    icon: ProductsLogo,
    comingSoon: false
  },
  {
    label: fmt({
      id: `store_design.sections_modal.categories`
    }),
    image: intl.locale === 'en' ? CategoriesPreview : CategoriesPreviewAr,
    sectionDefaultData: {
      type: 'categories',
      isNewAdded: true,
      title: 'Featured Categories',
      titleAr: 'فئات مميزه',
      name: 'featuredCategories',
      selectedCategories: []
    },
    icon: CategoriesLogo,
    comingSoon: false
  },
  {
    label: fmt({
      id: `store_design.sections_modal.testimonials`
    }),
    image:
      intl.locale === 'en' ? CustomerReviewsPreview : CustomerReviewsPreviewAr,
    sectionDefaultData: {
      ...CUSTOMER_REVIEWS_INITIAL_VALUES,
      isNewAdded: true
    },
    icon: CustomerReviewsLogo,
    comingSoon: false
  },
  {
    label: fmt({
      id: `store_design.sections_modal.benefits`
    }),
    image: Benefits,
    sectionDefaultData: {
      ...BENEFITS_INTIAL_VALUES,
      isNewAdded: true
    },
    icon: LogoListIcon,
    comingSoon: false
  },
  {
    label: fmt({
      id: `store_design.sections_modal.video`
    }),
    image: intl.locale === 'en' ? VideosPreview : VideosPreview,
    sectionDefaultData: {
      name: 'video',
      type: 'video',
      title: 'Video',
      isNewAdded: true,
      layout: VIDEO_LAYOUT_TYPES.DEFAULT,
      colorScheme: 'LIGHT'
    },
    icon: PlayIcon,
    comingSoon: false
  },
  {
    label: fmt({
      id: `store_design.sections_modal.logo_list`
    }),
    icon: LogoListIcon,
    image: logoList,
    sectionDefaultData: {
      type: 'logos',
      isNewAdded: true,
      title: 'Logo List',
      titleAr: 'قائمة الشعار',
      name: 'logoList',
      list: Array(4).fill(''),
      colorScheme: 'LIGHT'
    },
    comingSoon: false
  },
  {
    label: fmt({
      id: `store_design.sections_modal.video`
    }),
    icon: PlayIcon,
    comingSoon: true
  },
  {
    label: fmt({
      id: `store_design.sections_modal.news`
    }),
    icon: MailIcon,
    comingSoon: true
  },
  {
    label: fmt({
      id: `store_design.sections_modal.map`
    }),
    icon: MarkerIcon,
    comingSoon: true
  }
];

export const STORE_EDITOR_PANEL_KEYS = {
  DESIGN: 'design-style',
  HOMEPAGE: 'home-page'
};

export const STORE_EDITOR_THEMES = ['proTheme1', 'classic'];

export const BASIC_THEME = 'basic';

export const DEFAULT_LINKS = [
  {
    title: 'Home Page',
    titleAr: 'الرئيسية',
    value: '/home',
    isEditable: false
  },
  {
    title: 'Shop',
    titleAr: 'تسوق',
    value: '/shop',
    isEditable: false
  },
  {
    title: 'Sale',
    titleAr: 'خصومات',
    value: '/sale',
    canBeHidden: true,
    isHidden: false,
    isEditable: false
  }
];

export const SECTIONS = [
  'banner',
  'products',
  'categories',
  'customerReviews',
  'logos',
  'video',
  'benefits'
];

export const SECTION_ICON_MAPPER = {
  banner: <BannerLogo />,
  products: <ProductsLogo />,
  categories: <CategoryLogo />,
  customerReviews: <CustomerReviewsLogo />,
  video: <PlayIcon />,
  benefits: <LogoListIcon />,
  logos: <LogoListIcon />
};
export const BANNER_BILINGUAL_INPUTS = (item) => [
  {
    inputName: ['title'],
    inputNameAr: ['titleAr'],
    inputTitle: 'store_design.store_editor.homepage.sections.title_name',
    defaultInputValue: {
      en: item?.title,
      ar: item?.titleAr
    },
    maxCount: 60
  },
  {
    inputName: ['description'],
    inputNameAr: ['descriptionAr'],
    inputTitle: 'support_tickets.create_ticket.labels.description',
    defaultInputValue: { en: item?.description, ar: item?.descriptionAr },
    isTextArea: true,
    maxCount: 300
  },
  {
    inputName: ['cta', 'label'],
    inputNameAr: ['cta', 'labelAr'],
    inputTitle: 'store_design.store_editor.homepage.sections.btn_label',
    defaultInputValue: {
      en: item?.cta?.label,
      ar: item?.cta?.labelAr
    },
    placeholderId: 'store_design.store_editor.enter_btn',
    maxCount: 30
  }
];

export const SECTION_ITEM_LEVEL = {
  PRODUCT: 'product',
  CATEGORY: 'category'
};

export const DEFAULt_HOMEPAGE_SECTIONS = [
  {
    type: 'banner',
    title: 'Banner',
    titleAr: 'صور رئيسية',
    name: 'banner',
    bannerHeight: 'large',
    buttonSize: 'medium',
    bannerAlignment: 'center',
    colorScheme: 'LIGHT',
    layout: BANNER_LAYOUT_TYPES.DEFAULT,
    banners: [
      {
        title: 'Our New Collection is Here!',
        titleAr: 'مجموعتنا الجديدة هنا!',
        description:
          'Don’t miss out on our new collection. Shop our latest products and get the best offers.',
        descriptionAr:
          'لا تفوت مجموعتنا الجديدة. تسوق أحدث المنتجات واحصل على أفضل العروض.',
        cta: {
          label: 'Shop Now',
          labelAr: 'تسوق الآن',
          link: '/shop'
        }
      }
    ]
  },
  {
    type: 'products',
    title: 'Trending Products',
    titleAr: 'منتجات مميزه',
    apiKey: 'trending-products',
    categoryName: 'Trending Products',
    apiPayload: {
      page: 1,
      limit: 9
    },
    name: 'trendingProducts'
  },
  CUSTOMER_REVIEWS_INITIAL_VALUES,
  BENEFITS_INTIAL_VALUES,
  {
    type: 'logos',
    name: 'logoList',
    title: 'Logo List',
    titleAr: 'قائمة الشعار',
    colorScheme: 'LIGHT',
    list: Array(4).fill('')
  }
];

export const SECTION_TITLE = {
  banner: 'store_design.sections_modal.banner',
  products: `nav_bar.products`,
  categories: `store_design.sections_modal.categories`,
  customerReviews: `store_design.sections_modal.testimonials`,
  header: `store_design.store_editor.homepage.header.title`,
  footer: `store_design.store_editor.homepage.footer.title`,
  video: `store_design.sections_modal.video`,
  benefits: `store_design.sections_modal.benefits`,
  logos: `store_design.store_editor.homepage.sections.logos.title`
};

export const SECTION_DELETE_TEXT = {
  banner: {
    title: 'store_design.store_editor.homepage.sections.delete_banners_title',
    content:
      'store_design.store_editor.homepage.sections.delete_banners_content'
  },
  products: {
    title: 'store_design.store_editor.homepage.sections.delete_products_title',
    content:
      'store_design.store_editor.homepage.sections.delete_products_content'
  },
  categories: {
    title: 'store_design.categories_section.delete_title',
    content: 'store_design.categories_section.delete_subtitle'
  },
  customerReviews: {
    title: 'store_design.reviews_section.delete_confirmation_modal.title',
    content: 'store_design.reviews_section.delete_confirmation_modal.message'
  },
  benefits: {
    title: 'store_design.store_editor.homepage.sections.delete_benefits_title',
    content:
      'store_design.store_editor.homepage.sections.delete_benefits_content'
  },
  video: {
    title: 'store_design.reviews_section.delete_confirmation_modal.title',
    content: 'store_design.reviews_section.delete_confirmation_modal.message'
  },
  logos: {
    title: `store_design.store_editor.homepage.sections.logos.delete_title`,
    content: `store_design.store_editor.homepage.sections.logos.delete_subtitle`
  }
};
